import { render, staticRenderFns } from "./ProjectScopeForm.vue?vue&type=template&id=5b65c0ae&scoped=true&"
import script from "./ProjectScopeForm.vue?vue&type=script&lang=js&"
export * from "./ProjectScopeForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectScopeForm.vue?vue&type=style&index=0&id=5b65c0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65c0ae",
  null
  
)

export default component.exports